export const emptyCartImgage = '/assets/images/empty-cart.png';

export const TYPE_ADDRESS = {
  DELIVERY: 1,
  BILLING: 2
};
